"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CatalogCard = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var schemas_1 = require("@dcl/schemas");
var Mana_1 = require("../Mana/Mana");
var Card_1 = require("../Card/Card");
var Profile_1 = require("../Profile/Profile");
require("./CatalogCard.css");
var AssetImage_1 = require("../AssetImage/AssetImage");
var CatalogCard = function (props) {
    var action = props.action, actionIcon = props.actionIcon, asset = props.asset, extraInformation = props.extraInformation, imagensrc = props.imagensrc, notForSale = props.notForSale, owners = props.owners, price = props.price;
    return (react_1.default.createElement(Card_1.Card, { className: 'CatalogCard', link: true, id: asset.id }, asset ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(AssetImage_1.AssetImage, { name: asset.name, rarity: asset.rarity, src: imagensrc, className: 'catalog' }),
        react_1.default.createElement(Card_1.Card.Content, { "data-testid": "asset-card-content", className: 'catalog' },
            react_1.default.createElement(Card_1.Card.Header, { className: "catalogHeader" },
                react_1.default.createElement("div", { className: 'title' },
                    react_1.default.createElement("span", { className: 'textOverflow' }, asset.name),
                    asset.network === schemas_1.Network.MATIC && (react_1.default.createElement("span", { className: 'creator' },
                        react_1.default.createElement(Profile_1.Profile, { address: asset.creator, textOnly: true }))))),
            react_1.default.createElement("div", { className: 'CatalogItemInformation' },
                react_1.default.createElement("span", { className: (0, classnames_1.default)('extraInformation', notForSale && 'NotForSale') },
                    react_1.default.createElement("span", null, action),
                    ":\u00A0",
                    actionIcon && react_1.default.createElement("div", { className: 'mintIcon' })),
                price ? (react_1.default.createElement("div", { className: 'PriceInMana' },
                    react_1.default.createElement(Mana_1.Mana, { size: "large", network: asset.network, className: 'PriceInMana' }, price))) : (owners),
                extraInformation && (react_1.default.createElement("span", { className: 'extraInformation' }, extraInformation))),
            react_1.default.createElement("div", { className: 'badge', style: {
                    backgroundColor: schemas_1.Rarity.getColor(asset.rarity)
                }, title: asset.rarity },
                react_1.default.createElement("span", { className: 'text' }, asset.rarity))))) : null));
};
exports.CatalogCard = CatalogCard;
